import { notifyMessage } from '../../../shared/constants/notify-message';
import { Constants } from '../../constants/quotas';

interface ValidationResult {
  valid: boolean;
  message: string;
}

export class QuotaNestingTitleValidator {
  constructor(public readonly title: string) {}

  validate(): ValidationResult {
    if (!this.title) {
      return {
        valid: false,
        message: notifyMessage.warningMessage.MULTI_QUOTA_NESTING.EMPTY_TITLE,
      };
    }

    const titleRegex = new RegExp(Constants.NESTING_TITLE_REGEX);

    if (!titleRegex.test(this.title)) {
      return {
        valid: false,
        message: notifyMessage.warningMessage.MULTI_QUOTA_NESTING.INVALID_TITLE,
      };
    }

    return { valid: true, message: '' };
  }

  validateDuplication(existingTitles: string[] = []): ValidationResult {
    if (existingTitles.includes(this.title)) {
      return {
        valid: false,
        message:
          notifyMessage.warningMessage.MULTI_QUOTA_NESTING.DUPLICATE_TITLE.replace(
            '<NESTING_NAME>',
            this.title
          ),
      };
    }

    return { valid: true, message: '' };
  }
}
